import * as React from 'react';

import { get as getUser } from 'js/lib/user';

import CoachIcon from 'bundles/ai-coach-platform/components/branding/CoachIcon';
import { LearnerAvatar } from 'bundles/ai-coach-platform/components/building-blocks';
import type { CoachPersona } from 'bundles/ai-coach-platform/components/patterns/chat/types';
import { firstNameFromFullName } from 'bundles/ai-coach-platform/utils/nameParser';

import _t from 'i18n!nls/ai-coach-platform';

export const getCoachPersona = (): CoachPersona => ({
  name: 'Coach', // 'Coach' is intentionally not translated since it is a product name
  avatar: <CoachIcon size="medium" />,
});

/**
 * Custom hook that returns a memoized learner persona.
 */
export const useLearnerPersona = (): CoachPersona => {
  const { fullName, photo_120: photo120, photo } = getUser();

  return React.useMemo(
    () => ({
      name: firstNameFromFullName(fullName) ?? _t('You'),
      avatar: <LearnerAvatar imageUrl={photo120 ?? photo ?? null} />,
    }),
    [fullName, photo120, photo]
  );
};
